/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './VirtualBraindateSupportModal.style';

import messages from 'plugin/virtual-braindate/l10n/virtualBraindateL10n';
import AccessibleModal from 'src/shared/app/base/modal/component/AccessibleModal';
import useClearModalDispatch from 'src/shared/app/base/modal/hook/useClearModalDispatch';
import PrimaryButton from 'src/shared/ui/component/button/PrimaryButton';

const useStyles = createUseStyles(styles);

type Props = {
  handleClose?: () => void,
};

const VirtualBraindateSupportModal = ({ handleClose }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | State
   |----------------------------------------------------------------------------
   */

  const [forceClose, setForceClose] = React.useState(false);

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const dispatchClearModal = useClearModalDispatch();

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onCloseClick = () => {
    if (handleClose) {
      handleClose();
    }

    setForceClose(true);
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <AccessibleModal
      contentClass={classes.content}
      overlayClass={classes.overlay}
      label={intl.formatMessage(messages.permissionErrorLabel)}
      forceClose={forceClose}
      handleAfterClose={dispatchClearModal}
    >
      <p className={classes.message}>
        {intl.formatMessage(messages.noSupport)}
      </p>
      <PrimaryButton handleClick={onCloseClick}>
        {intl.formatMessage(messages.noSupportOK)}
      </PrimaryButton>
    </AccessibleModal>
  );
};

export default compose(React.memo)(VirtualBraindateSupportModal);
